import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.53 2.472a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06zM20.25 5.51v11.56L5.853 2.673q.225-.065.467-.093a49.3 49.3 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93M3.75 21.002V6.934l14.063 14.063L12 18.091l-7.165 3.582a.75.75 0 0 1-1.085-.67"
    }, null, -1)
  ])))
}
export default { render: render }